<template lang='pug'>
  div
    app-header
    .u-relative.u-overflow-hide
      section(style='background-image: url(/images/radio.jpg); background-size: cover')
        div(class='o-wrapper u-white u-py5')
          h2(class='u-fz-h1 u-mt2 u-mb3')
            span.u-fw-s-bold Somos primeros en
            br
            b cobertura regional

          p.u-white.u-fz-h5.u-mb2.u-mt0
            span Escúchanos en&nbsp;
            strong LABAYA, LOCUMBA, TOQUEPALA, MIRAVE

    section#c-about-content.c-info-company__wrapper.u-flex.u-items-center.u-relative.u-bg-dark
      ul.c-info-company__list(v-if='companyInfos.length > 0')
        li.c-info-company__item(:class="infoSelected === companyInfo.title ? 'is-active' : ''", v-for='companyInfo in companyInfos')
          button.c-info-company__btn.u-pl0.u-fz-h3(@click='selectInfo(companyInfo.title)')
            i.u-icon.u-mr2 {{companyInfo.icon}}
            span.u-bold {{ companyInfo.title }}
          .c-info-company__content(v-html='companyInfo.content')
      img.c-info-company__image(class='u-show@tablet', src='/static/images/microphone.png')

    .u-py5
      h2.u-fz-h2.u-center.o-wrapper.u-color-tertiary.u-mt2
        span(class='u-inline-block u-fw-regular') NUESTRA&nbsp;
        b COBERTURA
      p.o-wrapper.u-mb5.u-block.u-center.u-color-text(class='u-10/12@tablet')
        | Conforme al Registro Nacional de Frecuencias del Ministerio de Transportes y Comunicaciones, Radio Corporación Calizaya - Radio RCC, cuenta con las siguientes frecuencias debidamente autorizadas mediante sus correspondientes Resoluciones Ministeriales vigentes:
      .u-mx-auto(style='width: 80%', v-if='frequencies.length > 0')
        swiper(:options='swiperFrecuencies')
          swiper-slide.u-flex-column(v-for='(frequency, index) in frequencies', :key='index')
            h2.u-color-primary.u-fz-h3.u-mb2.u-bold.u-block {{ frequency.name }}
            span {{ frequency.status }}
            ul.u-list-none.u-pl0(v-if='frequency.locations.length > 0')
              li.u-flex.u-mb2(v-for='location in frequency.locations')
                i.u-icon.u-color-primary.u-mr2 circle
                span {{ location }}
    app-footer
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'AboutScreen',

    computed: {
      ...mapGetters({
        companyInfos: 'companyInfos',
        company: 'company',
        frequencies: 'frequencies'
      })
    },

    data () {
      return {
        infoSelected: '',
        swiperFrecuencies: {
          autoplay: 5000,
          slidesPerView: 4,
          spaceBetween: 20,
          loop: true,
          grabCursor: true,
          breakpoints: {
            480: {
              slidesPerView: 1
            },
            768: {
              slidesPerView: 2
            },
            1200: {
              slidesPerView: 3
            }
          }
        }
      }
    },
    methods: {
      selectInfo (value) {
        if (this.infoSelected === value) {
          this.infoSelected = ''
        } else {
          this.infoSelected = value
        }
      },
      moveDown () {
        window.$('body').animate({scrollTop: window.$('#c-about-content').offset().top}, '1000', 'swing')
      }
    },
    created () {
      this.infoSelected = this.companyInfos[0].title
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/screens/About/components/AboutScreen.vue